
    export const getWukuPetenget = () => null;
    export default {};
  